import React, { useState, useEffect ,useRef} from 'react';
import { Bar } from 'react-chartjs-2';
import AxiosInstance from '../AxiosInstance';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import Layout from './Layout';
import { ArrowLeftCircle } from "react-bootstrap-icons";
import {  Button, Row, Col } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../ToastNotification';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GraphRepresentation = () => {
  const currentMonth = new Date().getMonth() + 1; 
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const [performanceData, setPerformanceData] = useState([]); 
  const [month, setMonth] = useState(currentMonth.toString());  
  const [year, setYear] = useState(currentYear.toString());   
  const [loading, setLoading] = useState(false); 
  const toastRef = useRef(null);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const capitalize = (str) => {
    if (!str) return '';  
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchPerformanceData = async () => {
      setLoading(true);
      try {
        const response = await AxiosInstance.get('/admin/monthperformance', {
          params: { month, year },
        });

        if (Array.isArray(response.data)) {
          setPerformanceData(response.data);
        } else {
         toastRef.current?.showToast('Invalid data format received:', response.data,"danger");
        }
      } catch (error) {
        toastRef.current?.showToast('Error fetching performance data:', "danger");
      } finally {
        setLoading(false);
      }
    };

    fetchPerformanceData();
  }, [month, year]);

  const chartData = {
    labels: performanceData.map((data) => 
      `${capitalize(data.first_name)} ${capitalize(data.last_name)}`
    ), 
    datasets: [
      {
        label: 'Total Work Hours',
        data: performanceData.map((data) => data.total_hours), // Y-axis
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: `Employee Work Hours for ${months[month - 1]} ${year}`,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `Hours: ${tooltipItem.raw}`,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Employee',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Work Hours',
        },
        beginAtZero: true,
      },
    },
  };

  return (
  <Layout heading="Monthly Performance">
  <Row className="mb-3">
    <Col xs={12}>
        <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
          <ArrowLeftCircle />
        </Button>
    </Col>
  </Row>
   <div className="container mt-4">
      <div className="row mb-3 g-2">
          <div className="col-12 col-md-auto">
            <select value={month} onChange={(e) => setMonth(e.target.value)} className="form-select">
              {months.map((monthName, index) => (
                <option key={index} value={index + 1}>
                  {monthName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-auto">
            <input
              type="number"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="form-control"
            />
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : performanceData.length > 0 ? (
          <div className="row">
            <div className="col-12">
              <div
                style={{
                  width: "100%",
                  overflowX: "auto",
                  textAlign: "center",
                  paddingBottom: "20px",
                }}
              >
                <div
                  style={{
                    minWidth: "400px",
                    maxWidth: "100%",
                    display: "block",
                    margin: "0 auto",
                  }}
                >
                  <Bar data={chartData} options={chartOptions} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No data available for the selected month and year.</p>
        )}
        <ToastNotification ref={toastRef} />
      </div>
  </Layout>
  );
};

export default GraphRepresentation;
